var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-col',{attrs:{"cols":"12"}},[_c('printer-stats-card',{staticClass:"mb-2 mb-sm-4"}),_c('printer-history-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }